import { useCallback } from 'react';
import Select from 'react-select';

const getSelectedColor = (variant) => {
  // captain selected background should be: #154353
  if (variant === 'captain') {
    return '#154353';
  }
  // owner selected background: #0C605C
  if (variant === 'owner') {
    return '#0C605C';
  }
  // renter selected background: #083170
  return '#083170';
};

const customStyles = {
  indicatorSeparator: () => ({
    display: 'none',
  }),

  control: (provided, state) => {
    const borderColor = state.isFocused ? '#8E9697' : 'hsl(0, 0%, 80%)';
    const borderColorHover = state.isFocused ? '#8E9697' : 'hsl(0, 0%, 70%)';
    const boxShadow = state.isFocused ? '0 0 0 1px #8E9697' : null;

    return {
      ...provided,
      borderColor,
      boxShadow,
      '&:hover': { borderColor: borderColorHover },
    };
  },

  option: (provided) => ({
    ...provided,
    '&:active': { backgroundColor: '#e2e4e6' },
  }),
};

export default function CustomSelect({ value, options, onChange, isSearchable, userVariant }) {
  const createTheme = useCallback(
    (theme) => ({
      ...theme,
      colors: {
        ...theme.colors,
        primary25: '#F5F7F9',
        primary: getSelectedColor(userVariant),
      },
    }),
    [userVariant]
  );

  return (
    <Select
      value={value}
      options={options}
      onChange={onChange}
      isSearchable={isSearchable}
      styles={customStyles}
      theme={createTheme}
    />
  );
}
